import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { HorizontalLine } from './HorizontalLine';
import Cookies from 'universal-cookie';

class YandexConnectPageWrapper extends React.Component {
    state = {
        website: null,
        loading: true,
        integrationCode: '',
        checkingCode: false,
        checkResult: null,
        integrations: {
            frontendCode: false,
            yandexMetrica: false,
            yandexDirect: false,
            googleAds: false
        },
        yandexMetrika: {
            connected: false,
            counters: [],
            selectedCounterId: null,
            loading: false,
            blockOnlyAdSessions: true
        },
        yandexSettings: {
            metrikaId: '105415078',
            metrikaName: 'zaryanovromain',
            directAccount: 'zaryanovromain',
            directType: 'Представительский аккаунт',
            protectedCampaigns: 1,
            blockOnlyAdSessions: true,
            triggerEvent: true
        },
        campaigns: [
            {
                id: '706286037',
                name: 'Единая перфоманс-кампания №3 от 14-01-2026',
                status: 'stopped'
            }
        ],
        selectedCampaigns: ['706286037'],
        websiteTariff: {
            name: 'Начальный',
            dailyCost: '100₽',
            monthlyVisits: 'до 10,000 визитов/мес',
            status: 'active',
            daysLeft: 7
        }
    }

    componentDidMount() {
        this.cookies = new Cookies();
       
        // Проверяем, если есть code в URL (редирект от Яндекса)
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code) {
            this.handleYandexCallback(code);
        }
    }




    

 
  

    goBack = () => {
        window.history.back();
    }

    

    handleYandexCallback = async (code) => {
        const cookies = new Cookies();
        const website_id = cookies.get('metrika_connecting_to_website')
        try {
             
            

            const token = this.cookies.get('clickanti_token');
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/yandex-connect/?code=${code}&website_id=${website_id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                // Убираем code из URL
                window.history.replaceState({}, document.title, window.location.pathname);
                
                // Обновляем данные
                //await this.checkYandexMetrikaConnection();
                
                alert('Яндекс.Метрика успешно подключена!');
            } else {
                const error = await response.json();
                //alert(`Ошибка подключения: ${error.error}`);
            }
        } catch (error) {
            console.error('Ошибка обработки коллбэка:', error);
            //alert('Произошла ошибка при подключении Яндекс.Метрики');
        }
        window.location = '/integrations/'+website_id
    }

    
    

    render() {
        const { website, loading, integrationCode, integrations, yandexSettings, campaigns, selectedCampaigns, websiteTariff, checkingCode, yandexMetrika } = this.state;

        if (loading) {
            return (
                <div className='createPage' style={{textAlign: 'center', padding: '4em'}}>
                    <div className='notCreatedText'>Загрузка...</div>
                </div>
            );
        }

       
    }
}


export default YandexConnectPageWrapper;